import { Carousel } from "antd";
import { CalendarEvent } from "./CalendarEvent";
import { CarouselContainer, NextButton, PrevButton } from "./styled";
import { MatchStatus } from "../../types/stats";
import { FC, ReactNode, useRef } from "react";
import { CarouselRef } from "antd/es/carousel";
import { ClockCircleOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import { MatchInfoShort } from "../../types/fixtures";
import { useTeamContext } from "../../hooks/useConfiguration";
import { getUrlByContext } from "../../utils";

interface CalendarCarouselProps {
    matches: MatchInfoShort[];
    lastItemLink?: string;
}

export const CalendarCarousel: FC<CalendarCarouselProps> = ({
    matches,
    lastItemLink,
}) => {
    const responsive = [
        {
            breakpoint: 1280,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: false,
            },
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: false,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: false,
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                //initialSlide: 1,
            },
        },
    ];

    let defaultSettings = responsive.findLast(v => v.breakpoint > document.documentElement.clientWidth)?.settings; 

    const settings = {
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        infinite: false,
        arrows: false,
        responsive,
        swipe: true,
        draggable: true,
        ...defaultSettings
    };

    const carouselRef = useRef<CarouselRef>(null);

    const nearestMatchIndex = matches.findIndex(
        (item) => (new Date(item.date)).getTime() > Date.now());

    console.log('Nearest index: ', nearestMatchIndex);

    let initialSlide = matches.length - settings.slidesToShow;
    if (nearestMatchIndex !== -1) {
        let s = defaultSettings || settings;

        initialSlide = nearestMatchIndex - (s.slidesToShow || 1) + 1;
    }

    if (initialSlide < 0) {
        initialSlide = 0;
    }

    const teamName = useTeamContext();

    return (
        <CarouselContainer className="rounded-sm">
            <Carousel {...settings} ref={carouselRef} initialSlide={initialSlide}>
                {matches.map((match) => {
                    let scoreText: ReactNode = '';
                    if (match.status === MatchStatus.FINISHED) {
                        scoreText = match.score;
                        scoreText = <span className="text-5xl font-bold">{match.score}</span>;
                    } else if (match.status === MatchStatus.IN_PROGRESS) {
                        scoreText = <span className="text-5xl font-bold animate-pulse">LIVE</span>
                    } else if (match.status === MatchStatus.UPCOMING) {
                        //scoreText = '-';
                    } else if (match.status === MatchStatus.CANCELED) {
                        scoreText = <span className="text-orange-400 text-xl"><ClockCircleOutlined /></span>;
                    }

                    const date = new Date(match.date);
                    let dateTime = 'Дата не определена';
                    if (!match.preliminaryDate && !isNaN(date.getTime())) {
                        if (!date.getHours() && !date.getMinutes()) {
                            dateTime = date.toLocaleDateString('ru-RU', {
                                day: 'numeric',
                                month: 'long'
                            });
                        } else {
                            dateTime = date.toLocaleDateString('ru-RU', {
                                day: 'numeric',
                                month: 'long',
                                hour: '2-digit',
                                minute: '2-digit',
                            });
                        }
                    }

                    const matchUrl = getUrlByContext(`/matches/matchcenter/${match.id}/`, teamName);

                    return (
                        <div key={match.id} className="min-w-64 px-1 select-none box-border">
                            <CalendarEvent
                                name={match.tournament.name}
                                url={getUrlByContext(match.tournament.url, teamName)}
                                date={dateTime}
                                team1={match.homeTeam}
                                team2={match.guestTeam}
                                score={scoreText}
                                matchUrl={matchUrl}
                                ticketUrl={match.status === MatchStatus.UPCOMING ? match.links?.ticketUrl : undefined}
                            //parkingUrl={match.status === MatchStatus.UPCOMING ? match.parkingUrl : undefined}
                            />
                        </div>
                    )
                })}
            </Carousel>
            <PrevButton onClick={() => carouselRef.current?.prev()} className="transition-all active:bg-slate-300 hover:bg-slate-100">
                <LeftOutlined />
            </PrevButton>
            <NextButton onClick={() => {
                /*if (carouselRef?.current && carouselRef.current.innerSlider.state.currentSlide + 1 > initialSlide) {
                    return window.open(lastItemLink || '/calendar', '_self');
                }*/
                carouselRef.current?.next();
            }}
                className="transition-all active:bg-slate-300 hover:bg-slate-100"
            >
                <RightOutlined />
            </NextButton>
        </CarouselContainer>
    );
}